<template>
  <div class="man band-card">
    <ball></ball>
    <div class="nav">
      <Nav :title="navTitle" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <van-form validate-first  @submit="submit">
      <van-field
        readonly
        required
        clickable
        disabled
        size="large"
        label="证件类型"
        :value="certificateNoTypeName"
        placeholder="选择证件类型"
        :rules="[{ required: true, message: '请选择证件类型' }]"
      />
      <van-field
        v-model="form.certificateNo"
        required
        type="textarea"
        rows="1"
        autosize
        disabled
        size="large"
        label="证件号码"
        placeholder="请输入证件号码"
        :rules="[
          {
            required: true,
            message: '证件号码格式不正确',
            validator: certificateNoValidator,
          },
        ]"
        @blur="getIdname(form.certificateNo)"
      />
      <van-field
        v-model="form.clientName"
        required
        size="large"
        label="姓名"
        disabled
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '姓名不能为空' }]"
      />

      <van-field
        label="性别"
        required
        size="large"
        :rules="[{ required: true, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group
            v-model="form.genderId"
            direction="horizontal"
            size="large"
          >
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        readonly
        required
        clickable
        size="large"
        label="出生日期"
        v-model="form['birthDay']"
        placeholder="选择出生日期"
        @click="showPicker['birthDay'] = true"
        :rules="[{ required: true, message: '请选择出生日期' }]"
      />
      <van-field
        readonly
        required
        clickable
        size="large"
        label="民族"
        :value="pickerValue['nation']"
        placeholder="选择民族"
        @click="showPicker['nation'] = true"
        :rules="[{ required: true, message: '请选择民族' }]"
      />

      <van-field
        v-model="form.phoneNumber"
        required
        size="large"
        label="手机号码"
        placeholder="请输入手机号码"
        :rules="[
          {
            required: true,
            message: '手机号码格式不正确',
            validator: certificatePhone,
          },
        ]"
      />
      <van-field
        readonly
        required
        clickable
        size="large"
        label="职业类型"
        :value="pickerValue['profession']"
        placeholder="选择职业类型"
        @click="showPicker['profession'] = true"
        :rules="[{ required: true, message: '请选择职业类型' }]"
      />
      <div class="submit" v-if="ishaveID">
        <van-button
          class="bottom_button"
          round
          block
          type="info"
          native-type="submit"
          size="nomal"
          >建档并绑定</van-button
        >
      </div>
    </van-form>
    <div class="empty"></div>
    <van-popup v-model="showPicker['certificateType']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="IdCardList"
        value-key="name"
        @cancel="showPicker['certificateType'] = false"
        @confirm="(value) => onConfirm(value, 'certificateType')"
      />
    </van-popup>
    
    <van-popup v-model="showPicker['nation']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="nationOBJ"
        value-key="name"
        @cancel="showPicker['nation'] = false"
        @confirm="(value) => onConfirm(value, 'nation')"
      />
    </van-popup>
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        :value="showareanum"
        @confirm="onConfirm1"
        @cancel="showArea = false"
      />
    </van-popup>
        <van-popup v-model="showPicker['profession']" round position="bottom">
      <van-picker
        show-toolbar
        :columns="professionOBJ"
        value-key="name"
        @cancel="showPicker['profession'] = false"
        @confirm="(value) => onConfirm(value, 'profession')"
      />
    </van-popup>
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import provinceOBJ from "@/utils/area.js";
// import { Picker,Toast } from 'vant';
import area from "@/utils/area1.js";
export default {
  mixins: [setOptions],
  data() {
    return {
      showareanum:"",
      birthplace:"",
      area:area,
      ispath:null,
      ncode: [],
      nname: [],
      nations: {},
      nationId:"",
      nations1: {},
      nations2: {},
      nationalityIds: "",
      nationalityId: "",
      nationalityId1: "",
      nationalityName1: "",
      nationalityId2: "",
      nationalityName2: "",
      showArea: false,
      areaList: provinceOBJ,
      province: {},
      professionOBJ: [],
      navTitle: "建立医院档案",
      ishaveID: true,
      value: "",
      IdCardList: [],
      nationOBJ: [
        { value: "01", name: "汉族" },
        { value: "02", name: "蒙古族" },
        { value: "03", name: "回族" },
        { value: "04", name: "藏族" },
        { value: "05", name: "维吾尔族" },
        { value: "06", name: "苗族" },
        { value: "07", name: "彝族" },
        { value: "08", name: "壮族" },
        { value: "09", name: "布依族" },
        { value: "10", name: "朝鲜族" },
        { value: "11", name: "满族" },
        { value: "12", name: "侗族" },
        { value: "13", name: "瑶族" },
        { value: "14", name: "白族" },
        { value: "15", name: "土家族" },
        { value: "16", name: "哈尼族" },
        { value: "17", name: "哈萨克族" },
        { value: "18", name: "傣族" },
        { value: "19", name: "黎族" },
        { value: "20", name: "傈僳族" },
        { value: "21", name: "佤族" },
        { value: "22", name: "畲族" },
        { value: "23", name: "高山族" },
        { value: "24", name: "拉祜族" },
        { value: "25", name: "水族" },
        { value: "26", name: "东乡族" },
        { value: "27", name: "纳西族" },
        { value: "28", name: "景颇族" },
        { value: "29", name: "柯尔克孜族" },
        { value: "30", name: "土族" },
        { value: "31", name: "达斡尔族" },
        { value: "32", name: "仫佬族" },
        { value: "33", name: "羌族" },
        { value: "34", name: "布朗族" },
        { value: "35", name: "撒拉族" },
        { value: "36", name: "毛难族" },
        { value: "37", name: "仡佬族" },
        { value: "38", name: "锡伯族" },
        { value: "39", name: "阿昌族" },
        { value: "40", name: "普米族" },
        { value: "41", name: "塔吉克族" },
        { value: "42", name: "怒族" },
        { value: "43", name: "乌孜别克族" },
        { value: "44", name: "俄罗斯族" },
        { value: "45", name: "鄂温克族" },
        { value: "46", name: "崩龙族" },
        { value: "47", name: "保安族" },
        { value: "48", name: "裕固族" },
        { value: "49", name: "京族" },
        { value: "50", name: "塔塔尔族" },
        { value: "51", name: "独龙族" },
        { value: "52", name: "鄂伦春族" },
        { value: "53", name: "赫哲族" },
        { value: "54", name: "门巴族" },
        { value: "55", name: "珞巴族" },
        { value: "56", name: "基诺族" },
      ],
      // provinceOBJ: [],
      showPicker: {
        certificateType: false,
        birthDay: false,
        nation: false,
        province: false,
        nationalityName: false,
        profession:false,
      },
      pickerValue: {
        certificateType: "居民身份证",
        nation: "",
        nativePlaceId:"",
        profession: "自由职业者",
      },
      form: {
        clientName: "",
        genderId: "",
        certificateType: "",
        certificateNo: "",
        phoneNumber: "",
        profession: "51",
        nation: "",
        nationalityId: "156",
        hkProvinceId:"",
        hkProvinceName:"",
        hkCityId:"",
        hkCityName:"",
        hkCountyId:"",
        hkCountyName:"",
         pactId: "1",

      },
      minDate: new Date(1888, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      userInfo: [],
      certificateNoTypeName: "",
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.getcoulms();
     if(this.$route.query.ispath){
      this.ispath=this.$route.query.ispath
    }
  },
  created() {},
  methods: {
    //根据身份证获得籍贯编号
     getaddressID(idCard) {
      if (!idCard || idCard.length < 6) return "";
      let provinceNo = idCard.substring(0, 2) + "0000";
      let cityNo = idCard.substring(0, 4) + "00";
      let countyNo = idCard.substring(0, 6);
      let provinceName = this.area.province_list[provinceNo];
      // console.log(provinceName)
      let cityName = this.area.city_list[cityNo];
      let countyName = this.area.county_list[countyNo];
      let result =
        {
          hkProvinceId:provinceNo,
          hkProvinceName:provinceName,
          hkCityId:cityNo,
          hkCityName:cityName,
          hkCountyId:countyNo,
          hkCountyName:countyName
        }

      return result;
    },
     getaddress_ID(idCard) {
         return idCard.substring(0,6)
    },
    //根据身份证号获取籍贯
     getaddress(idCard) {
      if (!idCard || idCard.length < 6) return "";
      let provinceNo = idCard.substring(0, 2) + "0000";
      let cityNo = idCard.substring(0, 4) + "00";
      let countyNo = idCard.substring(0, 6);

      let provinceName = this.area.province_list[provinceNo];
      // console.log(provinceName)
      let cityName = this.area.city_list[cityNo];
      let countyName = this.area.county_list[countyNo];

      let result =
        (provinceName ? provinceName : "") +
        "" +
        (cityName ? cityName : "") +
        "" +
        (countyName ? countyName : "");

      return result;
    },
    //nav返回
    onClickLeft() {
      this.$router.go(-1);
    },
    getBindFormData() {
      if (
        this.$route.query.clientName ||
        this.$route.query.certificateType ||
        this.$route.query.certificateNo
      ) {
        this.form.clientName = this.$route.query.clientName;
        this.form.certificateType = this.$route.query.certificateType;
        this.certificateNoTypeName = this.findValueByname(
          this.form.certificateType.toString(),
          this.IdCardList
        );
        this.form.certificateNo = this.$route.query.certificateNo;
        this.form.hkProvinceId=this.getaddressID(this.form.certificateNo).hkProvinceId
        this.showareanum=this.form.certificateNo.substring(0,6)
        this.form.hkProvinceName=this.getaddressID(this.form.certificateNo).hkProvinceName
        this.form.hkCityId=this.getaddressID(this.form.certificateNo).hkCityId
        this.form.hkCityName=this.getaddressID(this.form.certificateNo).hkCityName
        this.form.hkCountyId=this.getaddressID(this.form.certificateNo).hkCountyId
        this.form.hkCountyName=this.getaddressID(this.form.certificateNo).hkCountyName
        this.form.genderId = this.getgenderIDbyIdCard(
          this.$route.query.certificateNo
        );
        this.form.birthDay = this.getBirthdayFromIdCard(
          this.$route.query.certificateNo
        );
      }
    },
    //获取选项卡列表
    async getcoulms() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/hospitalconf/index/getObjType";
        let data = null;
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            // console.log(data);

            //证件类型
            this.IdCardList = data.data.idCardObj;
            //职业类型
            this.professionOBJ = data.data.professionOBJ;
            // 民族
            // this.nationOBJ =  data.data.nationOBJ;
            // 省/市/县
            // this.provinceOBJ =  data.data.provinceOBJ;
            // console.log(this.provinceOBJ);

            this.getBindFormData();
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },

    //身份证输入框失去焦点事件

    //通过身份证号获得性别
    getgenderIDbyIdCard(idcard) {
      if (parseInt(idcard.substr(16, 1)) % 2 == 1) {
        //男
        return "1";
      } else {
        //女
        return "2";
      }
    },
    //通过身份证获取生日
    getBirthdayFromIdCard(idCard) {
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }

      return birthday;
    },
    //根据对象value拿name
    findValueByname(value, info) {
      // for (let temp in info) {
      //   if (info[temp].value == value) {
      //     return info[temp].name;
      //   }
      // }
      return info.find((info) => info.value === value).name;
    },
    // 选中类型
    onConfirm(item, type) {
      if (type === "birthDay") {
        this.form[type] = this.formatDate(item);
        this.showPicker[type] = false;
        return;
      }
      this.pickerValue[type] = item.name;
      this.form[type] = item.value;
      this.showPicker[type] = false;
      if (type === "nation") {
        this.pickerValue[type] = item.name;
        this.form[type] = item.value;
        this.showPicker[type] = false;
        // console.log(this.nationId)
      }
    },
    onConfirm2(values,type,Provincename,Provinceid,Cityname,Cityid,Countyname,Countyid) {
      // console.log(values)
      this.pickerValue[type] = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.showArea = false;
      this.form[Provinceid]=values[0].code
      this.form[Provincename]=values[0].name
      this.form[Cityid]=values[1].code
      this.form[Cityname]=values[1].name
      this.form[Countyid]=values[2].code
      this.form[Countyname]=values[2].name
      this.showPicker[type] = false;
    },
    // 省市县选择
    onConfirm1(values) {
      this.value = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.showArea = false;
      // console.log(values);
      // var address = values.map(item=>item.name)
      values.forEach((item, index) => {
        var ncodes = item.code;
        this.ncode.push(ncodes);
        var nnames = item.name;
        this.nname.push(nnames);
        this.nationalityId = { addProvinceId: this.ncode[0] };
        this.nationalityId1 = { addCityId: this.ncode[1] };
        this.nationalityName1 = { addCityName: this.nname[1] };
        this.nations1 = Object.assign(
          this.nationalityId1,
          this.nationalityName1
        );
        this.nationalityId2 = { addCountyId: this.ncode[2] };
        this.nationalityName2 = { addCountyName: this.nname[2] };
        this.nations2 = Object.assign(
          this.nationalityId2,
          this.nationalityName2
        );
        // console.log(this.nations);
      });
    },
    // 证件号码校验
    certificateNoValidator(value) {
      if (this.form.certificateType === "1")
        return /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/.test(value);
      return true;
    },
    //手机号验证
    certificatePhone(value) {
      return /^1(3|4|5|6|7|8|9)\d{9}$/.test(value);
    },
    // 提交表单
    async submit() {
      // if(this.form.bloodType==""||this.form.nativePlaceId==""||this.form.clientName==""||this.form.genderId==""||this.form.certificateType==""||
      // this.form.certificateNo==""||this.form.birthDay==""||this.form.address==""||this.form.phoneNumber==""||this.form.nation==""
      //  ){
      //   this.$toast.fail('请完善信息')
      //   return
      // }
    //  console.log(this.form)
      try {
        this.$showLoad();
        //注册
        let zc_url = "/gauge/qrcreateclient";

        // console.log(this.form)
        await this.$axios_request.axios_request_body(
          "nodeserver",
          zc_url,
          "POST",
          this.form,
          (data) => {
            this.$hideLoad();
            // console.log("建档：：",data)
            if (data.status === 200) {
              this.$toast.success("注册并绑定成功");
              setTimeout(() => {
                this.$router.push('/mid');
              }, 1000);
            } else {
              this.$toast.fail("注册并绑定失败, 请核对信息重试");
            }
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("注册并绑定失败, 请核对信息重试");
      }
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  margin-bottom: 15px;
  .top {
    height: 50px;
  }
}
</style>
<style lang="scss">
.band-card {
  .van-cell {
    font-size: 16px;
  }
  .van-cell.van-cell--large {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .van-field__error-message {
    font-size: 14px;
  }
}
.van-field--disabled .van-field__label {
  color: #646566;
}
// 建档按钮
.submit {
  margin: 0px 0px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-items: center;
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .bottom_button {
    width: 90%;
    margin: 0px auto;
  }
}
.empty {
  height: 65px;
}
</style>